import { BaseEntity } from './base-entity';

export class Risk extends BaseEntity {
  survey: BaseEntity;
  threatType: string;
  rank: number;
  impact: number;
  probability: number;
  userOverride: boolean;
  description: string;
  override: boolean;
  requiresPlan: boolean;
  isDistributed: boolean;
  surveyParent: BaseEntity;

  estimatedCompletionMinutes: number;
}
